import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUIStore } from '../../store/ui-store';
import { useUserStore } from '../../store/user-store';
import EditCustomerDetails2 from '../../components/customers/edit-customer-details2';

function EditCustomerPage() {
  const { id } = useParams();
  const { currentUser, getUserDetails } = useUserStore();
  const { setTitle, setBreadcrumbs, clearBreadcrumbs } = useUIStore();

  useEffect(() => {
    if (currentUser) {
      setTitle(`${currentUser?.firstName}'s profile`);
      setBreadcrumbs([
        { link: '/customers', label: 'All users' },
        { link: `/customers/${id}`, label: 'View profile' },
      ]);
    }
  }, [currentUser, id, setBreadcrumbs, setTitle]);

  useEffect(() => {
    if (id) {
      getUserDetails(Number.parseInt(id, 10));
    }
  }, [getUserDetails, id]);

  useEffect(
    () => () => {
      clearBreadcrumbs();
    },
    [clearBreadcrumbs],
  );

  return (
    <div className="px-12 pt-10 pb-[35px]">
      {currentUser ? (
        <EditCustomerDetails2 user={currentUser} />
      ) : (
        <span>Loading...</span>
      )}
    </div>
  );
}

export default EditCustomerPage;
